import * as React from "react";
const SvgVideoFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-.946l2.94 1.838c1.332.832 3.06-.125 3.06-1.696V8.804c0-1.57-1.728-2.528-3.06-1.696L17 8.946V8a3 3 0 0 0-3-3z", clipRule: "evenodd" }));
export default SvgVideoFill;
